import React from "react";
import { Image } from "./image";

export const Legal = (props) => {
  return (
    <div id="legal" className="main">
      <div className="pb-10">
        <div className="legal">
          <div className="overlay">
            <div style={{ height: 800 }} className="container">
              <div className="content-row">
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="col-md-6 col-xs-offset-1 first-column"
                >
                  <div style={{ textAlign: "left", paddingTop: 50 }}>
                    <h1>02</h1>
                    <h2>{props.data ? props.data.title : ""}</h2>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    bottom: 70,
                  }}
                  className="col-md-5 second-column "
                >
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: 50,
                    }}
                  >
                    <div className="image"></div>
                    <div className="image2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-10">
        <div className="legal">
          <div className="overlay">
            <div className="container">
              <div className="content-row">
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="col-md-6 col-xs-offset-1 first-column-detail"
                >
                  <div
                    style={{ textAlign: "left", width: "80%", padding: "10%" }}
                  >
                    <Image
                      largeImage={props.data ? props.data.legal_1 : ""}
                      smallImage={props.data ? props.data.legal_1 : ""}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    bottom: 70,
                  }}
                  className="col-md-5 second-column"
                >
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: 50,
                    }}
                  >
                    <div className="image"></div>
                    <div className="image2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-10">
        <div className="legal">
          <div className="overlay">
            <div className="container">
              <div className="content-row">
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="col-md-6 col-xs-offset-1 first-column-detail"
                >
                  <div
                    style={{ textAlign: "left", width: "80%", padding: "10%" }}
                  >
                    <Image
                      largeImage={props.data ? props.data.legal_2 : ""}
                      smallImage={props.data ? props.data.legal_2 : ""}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    bottom: 70,
                  }}
                  className="col-md-5 second-column"
                >
                  <div
                    style={{
                      position: "relative",
                      paddingBottom: 50,
                    }}
                  >
                    <div className="image"></div>
                    <div className="image2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
